import { SvgIconProps } from '@material-ui/core';
import { Icon } from 'copilot-design-system';

export const ContractIcon = (props: SvgIconProps) => (
  <Icon icon="Contract" {...props} />
);
